<template>
    <canvas ref="canvas" class="romantic-canvas"></canvas>
  </template>
  
  <script>
  export default {
    mounted() {
      this.initCanvas();
      this.startAnimation();
    },
    methods: {
      initCanvas() {
        const canvas = this.$refs.canvas;
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
        this.ctx = canvas.getContext('2d');
        this.particles = [];
        this.stars = [];
        this.createStars();
        this.createHearts();
      },
      createStars() {
        for (let i = 0; i < 100; i++) {
          this.stars.push({
            x: Math.random() * this.$refs.canvas.width,
            y: Math.random() * this.$refs.canvas.height,
            size: Math.random() * 2 + 1,
            opacity: Math.random(),
          });
        }
      },
      createHearts() {
        for (let i = 0; i < 10; i++) {
          this.particles.push({
            x: Math.random() * this.$refs.canvas.width,
            y: Math.random() * this.$refs.canvas.height,
            size: Math.random() * 10 + 5,
            color: '#ff69b4',
            speed: Math.random() * 0.5 + 0.1,
            opacity: Math.random() * 0.5 + 0.5,
          });
        }
      },
      drawStars() {
        this.stars.forEach((star) => {
          this.ctx.beginPath();
          this.ctx.arc(star.x, star.y, star.size, 0, Math.PI * 2);
          this.ctx.fillStyle = `rgba(255, 255, 255, ${star.opacity})`;
          this.ctx.fill();
          star.opacity += (Math.random() - 0.5) * 0.1;
          if (star.opacity < 0) star.opacity = 0;
          if (star.opacity > 1) star.opacity = 1;
        });
      },
      drawHearts() {
        this.particles.forEach((particle) => {
          this.ctx.save();
          this.ctx.translate(particle.x, particle.y);
          this.ctx.scale(particle.size / 10, particle.size / 10);
          this.ctx.fillStyle = particle.color;
          this.ctx.globalAlpha = particle.opacity;
          this.ctx.beginPath();
          this.ctx.moveTo(0, 0);
          this.ctx.bezierCurveTo(-5, -10, -15, -10, -15, 0);
          this.ctx.bezierCurveTo(-15, 10, 0, 15, 0, 25);
          this.ctx.bezierCurveTo(0, 15, 15, 10, 15, 0);
          this.ctx.bezierCurveTo(15, -10, 5, -10, 0, 0);
          this.ctx.fill();
          this.ctx.restore();
  
          particle.y -= particle.speed;
          if (particle.y < -particle.size) {
            particle.y = this.$refs.canvas.height + particle.size;
            particle.x = Math.random() * this.$refs.canvas.width;
          }
        });
      },
      drawText() {
        this.ctx.font = '50px Arial';
        this.ctx.fillStyle = 'darkblue';
        this.ctx.textAlign = 'center';
        this.ctx.fillText(' ', this.$refs.canvas.width / 2, this.$refs.canvas.height / 2);
      },
      animate() {
        this.ctx.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
        this.drawStars();
        this.drawHearts();
        this.drawText();
        requestAnimationFrame(this.animate);
      },
      startAnimation() {
        this.animate();
      },
    },
  };
  </script>
  
  <style>
  .romantic-canvas {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to bottom, #000428, #004e92);
  }
  </style>
  